<template>
  <div>
    <div
      class="modal fade"
      id="customPropertyEditModal"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <form id="propertyEditForm">
            <div class="modal-header">
              <!-- Close button in the upper right corner -->
              <button
                type="button"
                class="close"
                @click="closeCustomPropertyEditDialog()"
              >
                ×
              </button>
              <!-- Modal Title -->
              <h4 class="modal-title">
                <b>{{ lang.SM2000 }}</b>
              </h4>
            </div>
            <div class="modal-body">
              <div class="panel panel-default">
                <div class="panel-body">
                  <div class="col-md-6">
                    <div
                      class="form-group searchbar col-md-6"
                      style="padding-left: 15px"
                    >
                      <input
                        type="search"
                        class="form-control"
                        :placeholder="lang.SM2001"
                        v-model="propertyTreeFilter"
                        @keydown.enter.prevent
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <button
                        type="button"
                        class="btn btn-raised btn-default"
                        @click="insertNewNode('Topic')"
                      >
                        {{ lang.SM2002 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-default"
                        :class="{
                          'btn-warning': isTreeDirty,
                          'btn-success': !isTreeDirty,
                        }"
                        @click="saveTree()"
                      >
                        {{ lang.SM2003 }}
                      </button>
                    </div>
                    <div class="col-md-12" id="customPropertiesTreeContainer">
                      <liquortree
                        v-if="propertyTreeData.Nodes"
                        :data="propertyTreeData.Nodes"
                        :filter="propertyTreeFilter"
                        :options="propertyTreeOptions"
                        ref="customPropertiesTree"
                        @node:selected="onPropertySelected"
                      >
                        <div
                          slot-scope="{ node }"
                          draggable="true"
                          class="draggable-tree-node"
                          :class="{ 'node-inactive': !node.data.Active }"
                          @dragover.prevent
                          @dragstart="ltDragStart(node, $event)"
                          @dragenter="ltDragEnter(node, $event)"
                          @dragleave="ltDragLeave(node, $event)"
                          @dragend="ltDragEnd(node, $event)"
                          @drop="ltDrop(node, $event)"
                        >
                          <i
                            v-if="node.data.Type === 'Topic'"
                            class="material-icons"
                            >title</i
                          >
                          <i
                            v-if="node.data.Type === 'Group'"
                            class="material-icons"
                            >group_work</i
                          >
                          <i
                            v-if="!node.data.Visible"
                            class="material-icons visibility-off"
                            >visibility_off</i
                          >
                          {{ node.text }}
                        </div>
                      </liquortree>
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    style="padding-left: 0"
                    v-if="selectedPropertyNodeData.Type"
                    @change="nodeDataChanged()"
                  >
                    <div class="form-group">
                      <label class="col-md-3 control-label">{{
                        lang.SM2004
                      }}</label>
                      <div class="col-md-9">
                        <label class="form-control text-left">{{
                          getTypeTranslation(selectedPropertyNodeData.Type)
                        }}</label>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputPropertyName"
                        class="col-md-3 control-label"
                        >{{ lang.SM2005 }} *</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputPropertyName"
                          v-model="selectedPropertyNodeData.Title"
                        />
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="selectedPropertyNodeData.Type === 'Property'"
                    >
                      <label
                        for="inputPropertyInputType"
                        class="col-md-3 control-label"
                        >{{ lang.SM2006 }}</label
                      >
                      <div class="col-md-9">
                        <select
                          class="form-control"
                          id="inputPropertyInputType"
                          v-model="selectedPropertyNodeData.PropertyType"
                          :disabled="selectedPropertyNodeData.HasShopperValues"
                        >
                          <option
                            v-for="(inputType, index) in inputPropertyTypesList"
                            :key="index"
                            :value="inputType"
                          >
                            {{ inputType }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        selectedPropertyNodeData.PropertyType ===
                          'SingleSelect' ||
                        selectedPropertyNodeData.PropertyType === 'MultiSelect'
                      "
                    >
                      <label class="col-md-3 control-label">{{
                        lang.SM2007
                      }}</label>
                      <div class="col-md-9 text-left">
                        <button
                          type="button"
                          class="btn btn-raised btn-default"
                          style="margin: 5px"
                          @click="showPropertyListEditModal = true"
                        >
                          {{ lang.SM2008 }}
                        </button>
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        selectedPropertyNodeData.PropertyType ===
                          'SingleSelect' ||
                        selectedPropertyNodeData.PropertyType === 'MultiSelect'
                      "
                    >
                      <label
                        id="labelAllowCustomListValues"
                        for="inputAllowCustomListValues"
                        class="col-md-3 control-label"
                      >
                        <span>
                          {{ lang.SM2036 }}
                          <i class="material-icons md-18 form-hint-icon"
                            >help_outline</i
                          >
                        </span>
                      </label>
                      <div class="col-md-9">
                        <div class="checkbox" style="float: left">
                          <label>
                            <input
                              type="checkbox"
                              id="inputAllowCustomListValues"
                              :value="
                                selectedPropertyNodeData.AllowCustomValues
                              "
                              v-model="
                                selectedPropertyNodeData.AllowCustomValues
                              "
                            />
                            <span class="checkbox-material">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                      <b-tooltip
                        target="labelAllowCustomListValues"
                        boundary="viewport"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SM2037 }}</b-tooltip
                      >
                    </div>
                    <div
                      class="form-group"
                      v-if="selectedPropertyNodeData.Type === 'Property'"
                    >
                      <label
                        id="labelPropertyRecommended"
                        for="inputPropertyRecommended"
                        class="col-md-3 control-label"
                      >
                        <span>
                          {{ lang.SM2034 }}
                          <i class="material-icons md-18 form-hint-icon"
                            >help_outline</i
                          >
                        </span>
                      </label>
                      <div class="col-md-9">
                        <div class="checkbox" style="float: left">
                          <label>
                            <input
                              type="checkbox"
                              id="inputPropertyRecommended"
                              :value="selectedPropertyNodeData.Recommended"
                              v-model="selectedPropertyNodeData.Recommended"
                            />
                            <span class="checkbox-material">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                      <b-tooltip
                        target="labelPropertyRecommended"
                        boundary="viewport"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SM2035 }}</b-tooltip
                      >
                    </div>
                    <div class="form-group">
                      <label
                        id="labelPropertyVisible"
                        for="inputPropertyVisible"
                        class="col-md-3 control-label"
                      >
                        <span>
                          {{ lang.SM2009 }}
                          <i class="material-icons md-18 form-hint-icon"
                            >help_outline</i
                          >
                        </span>
                      </label>
                      <div class="col-md-9">
                        <div class="checkbox" style="float: left">
                          <label>
                            <input
                              type="checkbox"
                              id="inputPropertyVisible"
                              :value="selectedPropertyNodeData.Visible"
                              v-model="selectedPropertyNodeData.Visible"
                            />
                            <span class="checkbox-material">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                      <b-tooltip
                        target="labelPropertyVisible"
                        boundary="viewport"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SM2027 }}</b-tooltip
                      >
                    </div>
                    <!-- <div class="form-group" v-if="selectedPropertyNodeData.Type === 'Group'">
                      <label
                        id="labelPropertyDynamic"
                        for="inputPropertyDynamic"
                        class="col-md-3 control-label"
                      >
                        <span>
                          {{lang.SM2010}}
                          <i class="material-icons md-18 form-hint-icon">help_outline</i>
                        </span>
                      </label>
                      <div class="col-md-9">
                        <div class="checkbox" style="float: left;">
                          <label>
                            <input
                              type="checkbox"
                              id="inputPropertyDynamic"
                              :value="selectedPropertyNodeData.Dynamic"
                              v-model="selectedPropertyNodeData.Dynamic"
                              :disabled="selectedPropertyNodeData.Guid"
                            />
                            <span class="checkbox-material">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                      <b-tooltip
                        target="labelPropertyDynamic"
                        boundary="viewport"
                        :delay="globals.tooltipDelay"
                      >{{lang.SM2028}}</b-tooltip>
                    </div>-->
                    <div class="form-group">
                      <label
                        id="labelPropertyActive"
                        for="inputPropertyActive"
                        class="col-md-3 control-label"
                      >
                        <span>
                          {{ lang.SM2011 }}
                          <i class="material-icons md-18 form-hint-icon"
                            >help_outline</i
                          >
                        </span>
                      </label>
                      <div class="col-md-9">
                        <div class="checkbox" style="float: left">
                          <label>
                            <input
                              type="checkbox"
                              id="inputPropertyActive"
                              :value="selectedPropertyNodeData.Active"
                              v-model="selectedPropertyNodeData.Active"
                            />
                            <span class="checkbox-material">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                      <b-tooltip
                        target="labelPropertyActive"
                        boundary="viewport"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SM2029 }}</b-tooltip
                      >
                    </div>
                    <div>
                      <button
                        type="button"
                        class="btn btn-raised btn-default"
                        v-if="
                          selectedPropertyNodeData.Guid &&
                          selectedPropertyNodeData.Type !== 'Property'
                        "
                        @click="insertNewNode('Property')"
                      >
                        {{ lang.SM2012 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-default"
                        v-if="
                          selectedPropertyNodeData.Guid &&
                          selectedPropertyNodeData.Type === 'Topic'
                        "
                        @click="insertNewNode('Group')"
                      >
                        {{ lang.SM2013 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-default"
                        v-if="
                          isCurrentNodeDirty || !selectedPropertyNodeData.Guid
                        "
                        @click="discardCurrentNodeChanges()"
                      >
                        {{ lang.SM2033 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-default"
                        :class="{
                          'btn-warning': isCurrentNodeDirty,
                          'btn-success': !isCurrentNodeDirty,
                        }"
                        @click="saveCurrentNode()"
                      >
                        {{ lang.SM2014 }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <CustomPropertyListEditModal
      :showModal="showPropertyListEditModal"
      :listGuid="selectedPropertyNodeData.ListGuid"
      @modalClosing="showPropertyListEditModal = false"
      @propertyListCreated="
        (selectedPropertyNodeData.ListGuid = $event), nodeDataChanged()
      "
    />
  </div>
</template>

<script>
import Vue from "vue";
import LiquorTree from "liquor-tree";
import Select2 from "../Tools/Select2";
import CustomPropertyListEditModal from "./CustomPropertyListEditModal";

Vue.component("liquor-tree", LiquorTree);
const baseLiquorTree = Vue.options.components["liquor-tree"];
const customLiquorTree = baseLiquorTree.extend({
  methods: {
    onDragStart(e) {
      return true;
    },
  },
});

export default {
  name: "CustomPropertyEditModal",
  components: {
    liquortree: customLiquorTree,
    Select2,
    CustomPropertyListEditModal,
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#customPropertyEditModal").on("hide.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    $("#customPropertyEditModal").on("shown.bs.modal", (e) => {
      if (!this.attentionMessageShown)
        this.globals.$emit("openGlobalNotificationDialog", {
          initiator: "CustomPropertyEditModalAttentionMessage",
          notificationTitle: this.lang.SM2015,
          colorRed: true,
          closeButtonText: this.lang.SM2016,
          htmlText: `<p><b>${this.lang.SM2017}</b></p>`,
        });
      this.attentionMessageShown = true;
    });
  },
  props: ["showDialog"],
  watch: {
    showDialog(newValue) {
      if (newValue) this.openCustomPropertyEditDialog();
      else this.closeCustomPropertyEditDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  data() {
    return {
      propertyTreeData: {},
      propertyTreeFilter: "",
      selectedPropertyNode: {},
      selectedPropertyNodeData: {},
      propertyTreeOptions: {
        parentSelect: true,
        multiple: false,
        propertyNames: {
          text: "Title",
          children: "ChildNodes",
        },
        filter: {
          matcher(query, node) {
            return (
              node.data.text.toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          },
        },
      },
      draggingTreeNode: null,
      currentDropTargetId: null,
      currentTreeNodes: null,
      isTreeDirty: false,
      isCurrentNodeDirty: false,
      showPropertyListEditModal: false,
      attentionMessageShown: false,
      inputPropertyTypesList: [
        "Checkbox",
        "SingleSelect",
        "MultiSelect",
        "Text",
        "Integer",
      ],
      lang: {
        SM2000: "Property Management",
        SM2001: "Search...",
        SM2002: "Add new topic",
        SM2003: "Save order",
        SM2004: "Type",
        SM2005: "Title",
        SM2006: "Input type",
        SM2007: "List",
        SM2008: "Edit selectable elements",
        SM2009: "Visible",
        SM2010: "Dynamic",
        SM2011: "Active",
        SM2012: "Insert new property",
        SM2013: "Insert new property group",
        SM2014: "Save unit",
        SM2015: "ATTENTION",
        SM2016: "OK",
        SM2017:
          "Changes in this view will have immediate impact on the user profile of all shoppers. So please be careful if you plan to save any changes.",
        SM2018: "Unsaved changes",
        SM2019: "Save",
        SM2020: "Discard",
        SM2021:
          "There are unsaved changes for the previous selected element. Do you want to save them?",
        SM2022: "Missing title",
        SM2023: "Element update successful",
        SM2024: "Element update failed",
        SM2025: "Order update successful",
        SM2026: "Order update failed",
        SM2027:
          "If an element is not visible, only MSM users can see it. It does not appear in the profile of shoppers.",
        SM2028:
          "Dynamic elements can have multiple entries in the shopper profile. Shoppers can add as many entries as they need.",
        SM2029:
          "If an element is inactive, it does never appear in the shopper profile. Even MSM users can not see it.",
        SM2030: "Topic",
        SM2031: "Group",
        SM2032: "Property",
        SM2033: "Discard changes",
        SM2034: "Recommended",
        SM2035:
          "A recommended property will be highlighted in the shopper profile",
        SM2036: "Allow custom values",
        SM2037:
          "In addition to the predefined values in the list the shopper is allowed to add custom values that are not part of the list.",
        SM2038: "Property tree data access failed",
        SM2039: "Property data access failed",
        SM2040: "Access denied",
      },
    };
  },
  methods: {
    ltDragStart(node, e) {
      e.dataTransfer.dropEffect = "move";
      this.draggingTreeNode = node;
      this.currentTreeNodes = $("#customPropertiesTreeContainer").find(
        ".tree-node"
      );
    },

    ltDragEnter(node, e) {
      let dNode = this.draggingTreeNode;
      let borderStyle = "solid 2px red";
      let borderPosition = "border-bottom";
      let targetNodeId = null;

      if (node.id === dNode.id) return false;

      if (dNode.data.Type === "Topic") {
        let targetTopic = node;
        while (targetTopic.data.Type !== "Topic")
          targetTopic = targetTopic.parent;
        targetNodeId = targetTopic.id;
      } else if (dNode.data.Type === "Group") {
        if (node.parent && node.parent.data.Type === "Group")
          targetNodeId = node.parent.id;
        else if (node.data.Type === "Topic" && node.children.length > 0) {
          targetNodeId = node.children[0].id;
          borderPosition = "border-top";
        } else targetNodeId = node.id;
      } else {
        if (node.data.Type !== "Property" && node.children.length > 0) {
          targetNodeId = node.children[0].id;
          borderPosition = "border-top";
        } else targetNodeId = node.id;
      }

      if (targetNodeId === dNode.id) return false; // Do not drop node on itself

      $("#customPropertiesTreeContainer")
        .find(`.tree-node[data-id="${targetNodeId}"]`)
        .css(borderPosition, borderStyle);
      this.currentDropTargetId = targetNodeId;
      return true;
    },

    ltDragLeave(node, e) {
      this.currentTreeNodes.css("border", "");
      this.currentDropTargetId = null;
    },

    ltDragEnd(node, e) {
      this.draggingTreeNode = null;
    },

    ltDrop(node, e) {
      this.currentTreeNodes.css("border", "");
      this.currentDropTargetId = null;
      this.currentTreeNodes = null;

      let dNode = this.draggingTreeNode;

      if (dNode.id === node.id) {
        return;
      }

      // Avoid moving topic or group inside itself
      if (
        dNode.data.Type === "Topic" &&
        node.parent &&
        (node.parent.id === dNode.id ||
          (node.parent.parent && node.parent.parent.id === dNode.id))
      )
        return;
      if (
        dNode.data.Type === "Group" &&
        node.parent &&
        node.parent.id === dNode.id
      )
        return;

      dNode.remove(); // Remove on old position

      // Find new position and insert dragged node
      if (node.data.Type === "Topic") {
        if (dNode.data.Type === "Topic") node.after(dNode);
        else node.prepend(dNode);
      }

      if (node.data.Type === "Group") {
        if (dNode.data.Type === "Topic") node.parent.after(dNode);
        else if (dNode.data.Type === "Group") node.after(dNode);
        else node.prepend(dNode);
      }

      if (node.data.Type === "Property") {
        if (dNode.data.Type === "Topic") {
          if (node.parent.data.Type === "Topic") node.parent.after(dNode);
          else node.parent.parent.after(dNode);
        } else if (dNode.data.Type === "Group") {
          if (node.parent.data.Type === "Group") node.parent.after(dNode);
          else node.after(dNode);
        } else node.after(dNode);
      }
      dNode.select();
      if (dNode.parent) dNode.parent.expand();

      this.isTreeDirty = true;
    },
    initCustomPropertyEditModal() {
      this.propertyTreeFilter = "";
      this.selectedPropertyNode = {};
      this.selectedPropertyNodeData = {};
    },
    openCustomPropertyEditDialog() {
      this.initCustomPropertyEditModal();
      this.getProperties();
      $("#customPropertyEditModal").modal("show");
    },
    closeCustomPropertyEditDialog() {
      if (this.isTreeDirty || this.isCurrentNodeDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", () => {
          this.isTreeDirty = false;
          this.isCurrentNodeDirty = false;
          $("#customPropertyEditModal").modal("hide");
        });
        return;
      }
      $("#customPropertyEditModal").modal("hide");
    },
    getProperties() {
      let queryString = "api/ShopperProperty/Tree";

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (!data) {
            console.error("No property data available");
            return;
          }
          this.propertyTreeData = {};
          this.$nextTick(() => {
            this.propertyTreeData = data;
            this.isTreeDirty = false;
            this.globals.doAfterNTicks(this, 2, () => {
              let treeRef = this.$refs.customPropertiesTree;
              if (!treeRef) return;
              treeRef.expandAll();
              let selectedProp = treeRef.find({
                data: { Guid: this.selectedPropertyNodeData.Guid },
              });
              if (selectedProp) {
                selectedProp.select();
                this.$nextTick(() => {
                  let el = document.querySelector(
                    `li[data-id="${selectedProp[0].id}"]`
                  );
                  let container = document.getElementById(
                    "customPropertiesTreeContainer"
                  );
                  if (!el || !container) return;
                  let nodeVisible = this.globals.isNodeVisibleInDOM(
                    el,
                    container,
                    false
                  );
                  if (!nodeVisible) el.scrollIntoView({ behavior: "smooth" });
                });
              }
            });
          });
        },
        error: () => {
          console.error("Property data access failed in getProperties()");
          this.globals.showErrorSnackbar(this.lang.SM2038);
        },
      });
    },
    getPropertyData() {
      let queryString = `api/ShopperProperty/Property/${this.selectedPropertyNode.data.Guid}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (!data) {
            console.error("No property data available");
          }
          this.selectedPropertyNodeData = data;
          this.isCurrentNodeDirty = false;
        },
        error: () => {
          console.error("Property data access failed in getPropertyData()");
          this.globals.showErrorSnackbar(this.lang.SM2039);
        },
      });
    },
    onPropertySelected(node) {
      if (!this.globals.isAccessAllowed("LoopOp_ShopperProperties_Read")) {
        this.globals.showErrorSnackbar(this.lang.SM2040);
        console.error("Access denied: LoopOp_ShopperProperties_Read");
        return;
      }

      if (this.isCurrentNodeDirty) {
        this.globals.$off("CustomPropertyUnsavedChangesYesConfirmation");
        this.globals.$once(
          "CustomPropertyUnsavedChangesYesConfirmation",
          () => {
            this.saveCurrentNode();
            this.isCurrentNodeDirty = false;
          }
        );
        this.globals.$off("CustomPropertyUnsavedChangesCloseDialog");
        this.globals.$once("CustomPropertyUnsavedChangesCloseDialog", () => {
          this.selectedPropertyNode = node;
          this.getPropertyData();
        });
        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "CustomPropertyUnsavedChanges",
          confirmationTitle: this.lang.SM2018,
          colorRed: true,
          yesButtonText: this.lang.SM2019,
          noButtonText: this.lang.SM2020,
          htmlText: `<p><b>${this.lang.SM2021}</b></p>`,
        });
        return;
      }
      this.selectedPropertyNode = node;
      this.getPropertyData();
    },
    discardCurrentNodeChanges() {
      if (this.selectedPropertyNode.id) {
        let node = this.$refs.customPropertiesTree.find({
          id: this.selectedPropertyNode.id,
        });
        node.unselect();
      }
      this.selectedPropertyNode = {};
      this.selectedPropertyNodeData = {};
      this.isCurrentNodeDirty = false;
    },
    nodeDataChanged() {
      this.isCurrentNodeDirty = true;
    },
    insertNewNode(type) {
      if (!this.globals.isAccessAllowed("LoopOp_ShopperProperties_Create")) {
        this.globals.showErrorSnackbar(this.lang.SM2040);
        console.error("Access denied: LoopOp_ShopperProperties_Create");
        return;
      }

      if (!type) return;

      let newNode = {};
      newNode.Type = type;
      newNode.Visible = false;
      newNode.Active = false;

      if (type !== "Topic") {
        newNode.ParentGuid = this.selectedPropertyNodeData.Guid;
        newNode.Dynamic = false;
      }
      if (type === "Property") {
        newNode.PropertyType = "Text";
        newNode.AllowCustomValues = false;
      }
      if (type === "Group") {
        newNode.Dynamic = true;
      }

      this.selectedPropertyNodeData = newNode;
    },
    cleanUpSelectedNode() {
      if (
        this.selectedPropertyNodeData.PropertyType !== "SingleSelect" &&
        this.selectedPropertyNodeData.PropertyType !== "MultiSelect"
      ) {
        delete this.selectedPropertyNodeData.AllowCustomValues;
        delete this.selectedPropertyNodeData.ListGuid;
      }
    },
    saveCurrentNode() {
      if (!this.globals.isAccessAllowed("LoopOp_ShopperProperties_Update")) {
        this.globals.showErrorSnackbar(this.lang.SM2040);
        console.error("Access denied: LoopOp_ShopperProperties_Update");
        return;
      }

      if (!this.selectedPropertyNodeData.Title) {
        this.globals.showErrorSnackbar(this.lang.SM2022);
        return;
      }

      this.cleanUpSelectedNode();

      let method = this.selectedPropertyNodeData.Guid ? "PUT" : "POST";
      let url = `api/ShopperProperty/Property/${
        this.selectedPropertyNodeData.Guid || ""
      }`;
      let dataString = JSON.stringify(this.selectedPropertyNodeData);

      $.ajax({
        method: method,
        url: url,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.SM2023);
          if (method === "POST") this.selectedPropertyNodeData = data;
          this.isCurrentNodeDirty = false;
          this.getProperties();
        },
        error: () => {
          console.error("Error on POST in saveCurrentNode()");
          this.globals.showErrorSnackbar(this.lang.SM2024);
        },
      });
    },
    saveTree() {
      if (!this.globals.isAccessAllowed("LoopOp_ShopperProperties_Update")) {
        this.globals.showErrorSnackbar(this.lang.SM2040);
        console.error("Access denied: LoopOp_ShopperProperties_Update");
        return;
      }

      let url = "api/ShopperProperty/Tree";
      let treeData = JSON.stringify({ Nodes: this.createTreeJSON() });

      $.ajax({
        method: "PUT",
        url: url,
        data: treeData,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.isTreeDirty = false;
          this.globals.showSuccessSnackbar(this.lang.SM2025);
        },
        error: () => {
          console.error("Error on POST in saveTree()");
          this.globals.showErrorSnackbar(this.lang.SM2026);
        },
      });
    },
    createTreeJSON() {
      let treeJSON = this.$refs.customPropertiesTree.toJSON();

      let transformNode = (node) => {
        let newNode = {
          Title: node.text,
          data: node.data,
        };
        if (newNode.data.text) delete newNode.data.text;
        if (node.children.length > 0)
          newNode.ChildNodes = _.map(node.children, transformNode);

        return newNode;
      };

      for (let i = 0; i < treeJSON.length; i++) {
        treeJSON[i] = transformNode(treeJSON[i]);
      }

      return treeJSON;
    },
    getTypeTranslation(type) {
      switch (type) {
        case "Topic":
          return this.lang.SM2030;
        case "Group":
          return this.lang.SM2031;
        case "Property":
          return this.lang.SM2032;
        default:
          return type;
      }
    },
  },
};
</script>

<style>
#CustomPropertyUnsavedChangesConfirmation .modal-header button.close {
  display: none;
}

#CustomPropertyEditModalAttentionMessageNotification
  .modal-header
  button.close {
  display: none;
}
#CustomPropertyEditModalAttentionMessageNotification > .modal-dialog {
  top: 100px;
}
</style>

<style scoped>
#customPropertiesTreeContainer {
  height: calc(100vh - 230px);
  overflow: auto;
}

.modal-content {
  background-color: #eee;
}

.modal-lg {
  width: calc(100vw - 450px);
}

.draggable-tree-node {
  width: 100%;
  text-align: left;
}
.draggable-tree-node > .material-icons {
  font-size: 24px;
  vertical-align: middle;
  margin-bottom: 3px;
  margin-right: 5px;
}
.draggable-tree-node > .material-icons.visibility-off {
  position: absolute;
  right: 0;
}

.node-inactive {
  color: lightgray;
}

.panel-body button.btn {
  padding: 8px;
}

.form-hint-icon {
  vertical-align: middle;
  cursor: pointer;
}

.form-group {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// CustomPropertyEditModal.vue?34940b86